import React from "react"
import useWindowDimensions from "@hooks/useWindowDimensions"
import { DesktopOtherArticles, TabletOtherArticles } from "./components"
import {
  StyledOtherArticlesWrapper,
  StyledOtherArticlesTitle,
} from "./styled"

const OtherArticles = (props) => {
  const { isDesktop } = useWindowDimensions()

  return (
    <StyledOtherArticlesWrapper>
      <StyledOtherArticlesTitle>Other articles</StyledOtherArticlesTitle>
      {isDesktop ? <DesktopOtherArticles {...props} /> : <TabletOtherArticles {...props} /> }
    </StyledOtherArticlesWrapper>
  )
}

export default OtherArticles
